"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Download = void 0;
var React = require("react");
var Download = function (_a) {
    var _b = _a.style, style = _b === void 0 ? {} : _b, _c = _a.fill, fill = _c === void 0 ? undefined : _c;
    return (React.createElement("svg", { width: "24px", height: "24px", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", style: style },
        React.createElement("defs", null,
            React.createElement("path", { 
                // tslint:disable-next-line:max-line-length
                d: "M12,12 L8,8 L11,8 L11,4 L13,4 L13,8 L16,8 L12,12 Z M19,4 C19.6,4 20,4.4 20,5 L20,19 C20,19.6 19.6,20 19,20 L5,20 C4.4,20 4,19.6 4,19 L4,5 C4,4.4 4.4,4 5,4 L8,4 L8,6 L6,6 L6,14 L18,14 L18,6 L16,6 L16,4 L19,4 Z M6,18 L18,18 L18,16 L6,16 L6,18 Z", id: "DOWNLOAD-SVG-ICON-PATH" })),
        React.createElement("g", { id: "Icon/Download", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            React.createElement("mask", { id: "DOWNLOAD-SVG-ICON-MASK", fill: "white" },
                React.createElement("use", { xlinkHref: "#DOWNLOAD-SVG-ICON-PATH" })),
            React.createElement("g", { id: "Mask", fillRule: "nonzero" }),
            React.createElement("g", { id: "Mixin/Fill/Black", mask: "url(#DOWNLOAD-SVG-ICON-MASK)", fill: fill || '#00242D' },
                React.createElement("rect", { id: "Rectangle", x: "0", y: "0", width: "24", height: "24" })))));
};
exports.Download = Download;
//# sourceMappingURL=Download.js.map